import { applicationSessionApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';

export const GET_ACTIVE_APPLICANTS = 'GET_ACTIVE_APPLICANTS';

export const getActiveApplicantsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationSessionApi.getActiveApplicationSession(params);

  return dispatch({
    type: GET_ACTIVE_APPLICANTS,
    payload: data,
  });
});
